import {observable} from 'mobx';


export default class UserStore {
    @observable public name = "";
}